// extracted by css-extract-rspack-plugin
export default {"dropzone":"CoverPictureInput__dropzone___KK4lc","iconStyle":"CoverPictureInput__iconStyle___Rs_ig","descriptionStyle":"CoverPictureInput__descriptionStyle___xgsvl"};